/**
 * AWG persona gallery swap.
 * Persona detection + html[data-wr-persona] is set inline in <head> (theme.liquid)
 * to prevent FOUC. This deferred script handles the gallery: removes hidden slides
 * from the DOM so the slider component counts/snaps correctly.
 */
(function () {
  var persona = document.documentElement.getAttribute('data-wr-persona');
  var hideAttr = persona === 'moto' ? 'data-persona-fishing' : 'data-persona-moto';
  var showAttr = persona === 'moto' ? 'data-persona-moto' : 'data-persona-fishing';

  // Remove hidden gallery slides and thumbnails from DOM so slider recalculates
  document.querySelectorAll(
    '.product__media-list [' + hideAttr + '], .thumbnail-list [' + hideAttr + ']'
  ).forEach(function (el) {
    el.remove();
  });

  // Keep inactive persona content out of both the visual and accessibility trees.
  document.querySelectorAll('[' + showAttr + ']').forEach(function (el) {
    el.hidden = false;
    el.inert = false;
    el.removeAttribute('aria-hidden');
  });
  document.querySelectorAll('[' + hideAttr + ']').forEach(function (el) {
    el.hidden = true;
    el.inert = true;
    el.setAttribute('aria-hidden', 'true');
  });

  // Re-activate the first visible slide if the current active was removed
  var gallery = document.querySelector('media-gallery');
  if (gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var firstSlide = null;
    if (viewer) {
      // Motorcycle traffic should immediately see the product being worn, not
      // the neutral featured image. Keep Shopify's featured media unchanged so
      // collection cards continue using the standard catalog image.
      firstSlide =
        persona === 'moto'
          ? viewer.querySelector('.product__media-item[data-persona-moto]')
          : viewer.querySelector('.product__media-item.is-active');
      firstSlide = firstSlide || viewer.querySelector('.product__media-item');

      if (firstSlide && (persona === 'moto' || !viewer.querySelector('.is-active'))) {
        viewer.querySelectorAll('.product__media-item.is-active').forEach(function (slide) {
          slide.classList.remove('is-active');
        });
        firstSlide.classList.add('is-active');
      }
    }
    // Reset slider pages so navigation counts are correct
    if (viewer && viewer.resetPages) {
      viewer.resetPages();
    }
    var thumbSlider = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbSlider && thumbSlider.resetPages) {
      thumbSlider.resetPages();
    }

    // media-gallery.js is deferred after this script. Once the custom element
    // is upgraded, use its public method to sync the active thumbnail and
    // slider position with the motorcycle-first selection above.
    if (persona === 'moto' && firstSlide && firstSlide.dataset.mediaId) {
      var activateMotoMedia = function () {
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(firstSlide.dataset.mediaId, false);
        }
      };
      if (customElements.get('media-gallery')) {
        activateMotoMedia();
      } else {
        customElements.whenDefined('media-gallery').then(activateMotoMedia);
      }
    }
  }
})();
